(function ($)
{
    $.widget("ui.StoryItemMenu",
        {
            options:
            {
                PageContentId: null
            },

            _destroy: function ()
            {
            },

            _init: function ()
            {
            },

            _create: function ()
            {
                const self = this;
                const jElement = $(self.element);

                if (self.options.PageContentId === null)
                {
                    return;
                }

                const jMenuContainer = jElement.find('.story_itemmenu');
                jMenuContainer.attr('role', 'region');
                jMenuContainer.attr('aria-live', 'polite');

                const jMoreContainer = jMenuContainer;

                jElement.AjaxContentPagination(
                    {
                        NavigationUrl: `/Core/Stories/ItemMenu/${self.options.PageContentId}/`,
                        LoadingTitle: "Item Menu",
                        NormalContainer: jMenuContainer,
                        MoreContainer: jMoreContainer
                    });
            }
        });
})(jQuery);
